import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { Observable } from 'rxjs';
import { TableColumnService } from '@shared/services/table-column.service';
import { CmSearchField, CmUiTableColumn as CmTableColumn, CompoundFilter } from '@cm/ui-modules';
import { select, Store } from '@ngrx/store';
import * as fromWorkflow from '../../../store';
import { map } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ObjectName } from '@view-model';
import { SHARED_IMPORTS } from '@shared/shared-imports';

@Component({
  selector: 'app-object-table',
  standalone: true,
  imports: [SHARED_IMPORTS],
  templateUrl: './object-table.component.html',
  styleUrls: ['./object-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectTableComponent implements OnInit {
  private tableColumnService = inject(TableColumnService);
  private store = inject<Store<fromWorkflow.State>>(Store);

  @Input()
  selectionType: 'multiple' | 'single' = 'single';

  @Input()
  selectedIds: any[] = [];

  @Input()
  objectName!: ObjectName;

  @Output()
  selectionChange = new EventEmitter<any[]>();

  isLoading$!: Observable<boolean>;

  columns$!: Observable<CmTableColumn[]>;

  rows$!: Observable<any[]>;

  rowCount$!: Observable<number>;

  pageIndex$!: Observable<number>;

  pageSize$!: Observable<number>;

  searchFields: CmSearchField[] = [];

  readonly pageSizeOptions: number[] = [5, 10, 25, 100];

  ngOnInit(): void {
    const objectName = this.objectName;
    this.columns$ = this.tableColumnService.getObjectColumns(objectName) as Observable<
      CmTableColumn[]
    >;
    this.searchFields = this.tableColumnService.getObjectSearchFields(objectName);
    this.store.dispatch(new fromWorkflow.LoadObjectList({ objectName }));

    this.store.dispatch(new fromWorkflow.FilterObjectList({ objectName, compoundFilter: null }));
    const list$ = this.store.pipe(select(fromWorkflow.getObjectListByObjectName(objectName)));
    this.rows$ = list$.pipe(map((list) => list.data));
    this.rowCount$ = list$.pipe(map((list) => list.total));
    this.isLoading$ = list$.pipe(map((list) => list.loading));
    this.pageIndex$ = list$.pipe(map((list) => list.pageIndex));
    this.pageSize$ = list$.pipe(map((list) => list.pageSize));
  }

  onCompoundFilterChange(compoundFilter: CompoundFilter) {
    const objectName = this.objectName;
    this.store.dispatch(new fromWorkflow.FilterObjectList({ objectName, compoundFilter }));
  }

  onPage({ pageSize, pageIndex }: PageEvent): void {
    const objectName = this.objectName;
    this.store.dispatch(new fromWorkflow.PageObjectList({ objectName, pageSize, pageIndex }));
  }

  onPageSort(event: Sort): void {
    const objectName = this.objectName;
    const orderByField = event.active;
    const order = event.direction === 'asc' ? 'ASCENDING' : 'DESCENDING';
    this.store.dispatch(new fromWorkflow.SortObjectList({ objectName, orderByField, order }));
  }
}
